import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ColoniaItem, ZipCodeDataItem } from 'src/app/model/zipcode-data-item';
import { CommonService } from 'src/app/services/common.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  @Output() addressForm:EventEmitter<FormGroup> = new EventEmitter();
  @Output() addressStepBack:EventEmitter<boolean> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    public commonService:CommonService,
    private msspService: MSSPService,
    private dialog: MatDialog
  ) { }
  
  formGroup: FormGroup = this.fb.group({
    street: ['', Validators.required],
    externalNumber: ['', Validators.required],
    internalNumber: [''],
    neighborhood: ['', Validators.required],
    postalCode: ['', [Validators.required, Validators.minLength(5)]],
    mayoralty: ['', Validators.required],
    state: ['', Validators.required]
  })

  get formControls() { return this.formGroup.controls };

  colonias: Array<ColoniaItem> = [];

  stepBack(){
    this.addressStepBack.emit(true)
  }

  stepOn(){
    this.addressForm.emit(this.formGroup)
    this.commonService.addressForm = this.formGroup
  }

  ngOnInit(): void {
    this.formControls['neighborhood'].disable();
    this.formControls['state'].disable();
    this.formControls['mayoralty'].disable();
  }

  searchDataFromZipCode(): void {
    const zipCode = this.formControls['postalCode'].value as string;
    if (zipCode.length === 5) {
      this.colonias = [];
      this.msspService.getDataFromZipCode(zipCode).subscribe(
        {
          next: (response: ZipCodeDataItem) => {
            this.formControls['state'].setValue(response.estado);
            this.formControls['mayoralty'].setValue(response.municipio);

            if(this.formControls['state'].disabled) {
              this.formControls['state'].enable();
            }

            if (this.formControls['mayoralty'].disabled) {
              this.formControls['mayoralty'].enable();
            }

            if (this.formControls['neighborhood'].disabled){
              this.formControls['neighborhood'].enable();
            }

            this.colonias = response.colonias;
            this.colonias.unshift({nombre:'', tipo: ''});
            this.formControls['neighborhood'].setValue('');

            this.formGroup.updateValueAndValidity({onlySelf: false});

          },
          error: (err: HttpErrorResponse) => {

            this.dialog.open(DialogMessageComponent, 
              {
                data: zipCode,
                height: '220px',
                width: '300px'
              }
            ).afterClosed().subscribe((result: boolean) => {
              this.colonias = [];
              this.formControls['state'].setValue('');
              this.formControls['mayoralty'].setValue('');
              this.formControls['neighborhood'].setValue('');

              if(this.formControls['state'].enabled) {
                this.formControls['state'].disable();
              }
  
              if (this.formControls['mayoralty'].enabled) {
                this.formControls['mayoralty'].disable();
              }
  
              if (this.formControls['neighborhood'].enabled){
                this.formControls['neighborhood'].disable();
              }
            })
          }
        }
      )
    }
  }

}
